import React from 'react';
import { useData } from '../../contexts/DataContext';
import { useTranslation } from 'react-i18next';
import { Domain } from '../../types/data';

interface DomainSelectorProps {
  activeDomain: Domain;
  setActiveDomain: (domain: Domain | null) => void;
}

const DomainSelector: React.FC<DomainSelectorProps> = ({ activeDomain, setActiveDomain }) => {
  const { domains, fetchRelatedDomainData } = useData();
  const { t } = useTranslation();
  return (
    <div>
      {activeDomain && (
        <div className="text-sm text-gray-600">
          <span className="capitalize  text-sm">
            <strong>{t('common.domain')}:</strong>
            <select
              value={activeDomain?.id || ''}
              onChange={(e) => {
                const selectedDomain = domains.find((domain) => domain.id === e.target.value);
                setActiveDomain(selectedDomain || null);
                fetchRelatedDomainData(e.target.value);
              }}
              className="ml-2 inline-block min-w-[150px] p-2 border rounded-md"
            >
              <option value="">{t('common.selectDomain')}</option>
              {domains.map((domain) => (
                <option key={domain.id} value={domain.id}>
                  {domain.domain}
                </option>
              ))}
            </select>
          </span>
          <span className="mx-4">|</span>
          <span className="capitalize text-sm">
            <strong>{t('common.language')}:</strong> {activeDomain.language}
          </span>
          <span className="mx-4 text-sms">|</span>
          <span className="capitalize">
            <strong>{t('common.location')}:</strong> {activeDomain.country}
          </span>
        </div>
      )}
    </div>
  );
};

export default DomainSelector;
